import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { BadgeProps } from '../jdsbadge/logic';
import { JDSListBlockProps } from './generated';
import { TagProps } from '../jdstag/logic';
import { TextProps } from '../jdstext/logic';
import { convertTextToComponent } from '../../utils/componenthelpers';

const legacySpacing = ['m', 's'] as const;
type legacySpacingType = (typeof legacySpacing)[number];

export interface ListBlockProps
  extends Omit<JDSListBlockProps, 'spacing' | 'isTitleVisible' | 'top'> {
  spacing?: legacySpacingType | JDSListBlockProps['spacing'];
  top?: string | React.ReactElement<TextProps>;
  ariaLabelledby?: string;
  ariaDescribedby?: string;
  captionBlock?: {
    /**
     * @deprecated
     * use `captionBlockText`
     */
    text: string | React.ReactElement<TextProps>;
    /**
     * @deprecated
     * use captionBlockHelper
     */
    helper?: string | React.ReactElement<TextProps | BadgeProps | TagProps>;
    /**
     * @deprecated
     * use captionBlockValue
     */
    value?: string | React.ReactElement<TextProps | BadgeProps | TagProps>;
  };
  titleBlock?: {
    /**
     * @deprecated
     * use `titleBlockText`
     */
    text: string | React.ReactElement<TextProps>;
    /**
     * @deprecated
     * use `titleBlockHelper`
     */
    helper?: string | React.ReactElement<TextProps | BadgeProps | TagProps>;
    /**
     * @deprecated
     * use `titleBlockValue
     */
    value?: string | React.ReactElement<TextProps | BadgeProps | TagProps>;
  };
  helperBlock?: {
    /**
     * @deprecated
     * use `helperBlockText`
     */
    text: string | React.ReactElement<TextProps>;
    /**
     * @deprecated
     * use `helperBlockHelper`
     */
    helper?: string | React.ReactElement<TextProps | BadgeProps | TagProps>;
    /**
     * @deprecated
     * use `helperBlockValue`
     */
    value?: string | React.ReactElement<TextProps | BadgeProps | TagProps>;
  };
}

export const PROP_MAP: IPROP_MAP<ListBlockProps> = (props) => {
  if (legacySpacing.includes(props.spacing as legacySpacingType)) {
    console.warn(
      'these values for the spacing prop are deprecated',
      legacySpacing
    );
  }
  return {
    captionBlock: {
      properties: {
        captionBlockText: convertTextToComponent(props.captionBlock?.text),
        captionBlockHelper: convertTextToComponent(props.captionBlock?.helper),
        captionBlockValue: convertTextToComponent(props.captionBlock?.value)
      }
    },
    titleBlock: {
      properties: {
        titleBlockText: convertTextToComponent(props.titleBlock?.text),
        titleBlockHelper: convertTextToComponent(props.titleBlock?.helper),
        titleBlockValue: convertTextToComponent(props.titleBlock?.value)
      }
    },
    helperBlock: {
      properties: {
        helperBlockText: convertTextToComponent(props.helperBlock?.text),
        helperBlockHelper: convertTextToComponent(props.helperBlock?.helper),
        helperBlockValue: convertTextToComponent(props.helperBlock?.value)
      }
    },
    spacing: {
      properties: {
        spacing: props.spacing
      },
      defaultValue: 's',
      variations: {
        s: {
          spacing: 'small'
        },
        m: {
          spacing: 'medium'
        }
      }
    }
  };
};

export const withLogic =
  (Component: React.ComponentType<ListBlockProps>): React.FC<ListBlockProps> =>
  (userProps: ListBlockProps) => {
    const props = modifyProps(userProps, PROP_MAP);

    return (
      <Component
        {...{
          ...props,
          _isTitleVisible: !(props.titleBlock?.text || props.titleBlockText)
        }}
      />
    );
  };
